<template>
    <div>
         <v-data-table
            :key="componentKey"
            :headers="computedHeaders"
            :items="tableItems"
            class="elevation-1"
            :loading="tempCoursesLoadStatus===1"
            hide-default-footer
            disable-pagination
            must-sort
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Grupy tymczasowe</v-toolbar-title>
                
                <!-- <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider> -->

                <v-spacer></v-spacer>
                <!-- <v-select
                        v-model="selectedCourse"
                        class="search"
                        :items="availableOtherCourses"
                        label="Wybierz grupę"
                        hide-details
                        dense
                      ></v-select>
                      <v-divider class="mx-4" inset vertical></v-divider>
                      <v-btn
                        :disabled="selectedCourse==0"
                        @click="addTempCourse"
                        x-small
                        class="mb-2 mt-2"
                        color="primary"
                      >
                        dodaj
                </v-btn> -->
                <!-- <v-divider
                  v-if="user.permissions['dictionary'] >= 10"
                  class="mx-4"
                  inset
                  vertical
                ></v-divider> -->
                <v-dialog v-model="dialog" max-width="700px">
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" small class="mb-2 mt-2" fab dark color="primary">
                      <v-icon dark>mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <v-card  :loading="tempCourseAddStatus===1">
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        
                           <v-row>                   
                            <v-col cols="12" sm="6" md="6">
                              <v-select :items="lookups.users" v-model="editedItem.user_id" :error-messages="user_idErrors" required @input="$v.editedItem.user_id.$touch()"  @blur="$v.editedItem.user_id.$touch()" label="Nauczyciel"></v-select>                            
                            </v-col>
                            <v-col cols="12" sm="6" md="6">
                              <v-select v-model="editedItem.course_id" :items="lookups.all_courses" :error-messages="course_idErrors" required @input="$v.editedItem.course_id.$touch()"  @blur="$v.editedItem.course_id.$touch()" label="Grupa"></v-select>
                            </v-col>
                           <v-col cols="12" sm="6" md="6">
                              <h4>Wybierz datę lub zakres dat:</h4>
                              <p>Uprawnienia będą nadane dla wskazanego okresu</p>
                              <v-chip v-if="validErrors.length>0" outlined small label color="error">{{validErrors[0]}}</v-chip>
                           </v-col>
                            <v-col cols="12" sm="6" md="6">
                              <v-date-picker range first-day-of-week="1" no-title v-model="editedItem.valid"></v-date-picker>
                            </v-col>
                            
                         
                          </v-row>
                          <v-row v-if="tempCourseAddStatus===3">
                                    <v-col class="d-flex flex-column align-center">
                                        <v-alert v-for="err in errorMessageArray(tempCourseAddText)" :key="err.index" dense outlined type="error">
                                          {{err}}
                                        </v-alert>    
                                    </v-col>
                            </v-row>     
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="gray" text @click="close">Anuluj</v-btn>
                      <v-btn color="primary darken-1" text @click="handleSubmit" >Zapisz</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>

            <template v-slot:item.user_name="{ item }">
              {{ item.user_name }} {{ item.user_surname }}
            </template>
             
             <template v-slot:item.valid_from="{ item }">
              {{ item.valid_from }}
                  <span v-if="item.valid_from!=item.valid_to">
                        {{' - ' + item.valid_to}}
                  </span>
            </template>



            <template v-slot:item.actions="{ item }">
                    <v-menu  bottom right close-on-click>
                          <template v-slot:activator="{ on }">
                            <v-btn v-on="on" color="primary" x-small>Przedłóż</v-btn>
                          </template>

                          <v-list>
                            <v-list-item @click="prolongTempCourse(item,'1d')"><v-list-item-title>Przedłóż o 1 dzień</v-list-item-title></v-list-item>
                            <v-list-item @click="prolongTempCourse(item,'3d')"><v-list-item-title>Przedłóż o 3 dni</v-list-item-title></v-list-item>
                            <v-list-item @click="prolongTempCourse(item,'1w')"><v-list-item-title>Przedłóż o 1 tydzień</v-list-item-title></v-list-item>
                            <v-list-item @click="prolongTempCourse(item,'2w')"><v-list-item-title>Przedłóż o 2 tygodnie</v-list-item-title></v-list-item>
                            <v-list-item @click="prolongTempCourse(item,'1m')"><v-list-item-title>Przedłóż o 1 miesiąc</v-list-item-title></v-list-item>
                            <v-list-item @click="prolongTempCourse(item,'fix')"><v-list-item-title>Ustaw stały dostęp</v-list-item-title></v-list-item>
                          </v-list>
                        </v-menu>
              
            </template>
            
          </v-data-table> 
          <confirm ref="confirm"></confirm>
        </div>
</template>

<script>
  import confirm from '../components/Confirm';
  import required from 'vuelidate/lib/validators/required'
     
  export default {
    components: { confirm },
    data: () => ({
      componentKey:0,
      selectedCourse:0,
      dialog: false,
      itemEditing:false,
      headers: [
        { text: '',align: 'start',sortable: false,value: 'lp',filterable:false,display:true},
        { text: 'Nauczyciel', value: 'user_name',filterable:true,filterColumn:"name",display:true },
        { text: 'Grupa', value: 'course_name',filterable:true,filterColumn:"course_name",display:true },
        { text: 'Aktywne', value: 'valid_from',filterable:true,filterColumn:"valid_from",display:true },
        { text: '', value: 'actions', sortable: false,filterable:false,display:true },
      ],
    }),
     validations: {
      editedItem:{
        user_id:{
          required,
        },
        course_id:{
          required,
        },
        valid:{
          required,
        },
      }
    },
    watch: {
      dialog (val) {
        this.$v.$reset()
        val || this.close()
      },
      tempCourseAddStatus(val){
        if(val===2){
          this.close();
          this.$store.dispatch( 'loadTempCourses' );
        }
      },
    },
    computed: {
      user(){
        return this.$store.getters.getUser;
      },
      lookups(){
        return this.$store.getters.getLookups;
      },
      editedItem(){
        return this.$store.getters.getTempCourseEdit;
      },
      tableItems(){
        return this.$store.getters.getTempCourses;
      },
      tempCoursesLoadStatus(){
        return this.$store.getters.getCoursesLoadStatus;
      },
      tempCourseAddStatus(){
        return this.$store.getters.getTempCourseAddStatus();
      },
      tempCourseAddText(){
        return this.$store.getters.getTempCourseAddText;
      },
      computedHeaders () {
        var localHeaders = [...this.headers.filter(h => h.display===true)]

        return localHeaders
      },
      formTitle () {
        return !this.itemEditing ? 'Nowy dostęp tymczasowy' : 'Edycja dostępu'
      },
      // availableOtherCourses(){
      //   return this.lookups.all_tempCourses.filter(u => !_.find(this.lookups.my_tempCourses,{'value':u.value}));
      // },
      user_idErrors () {
        const errors = []
        if (!this.$v.editedItem.user_id.$dirty) return errors
        !this.$v.editedItem.user_id.required && errors.push('Nauczyciel jest wymagany')
        return errors
      },
      course_idErrors () {
        const errors = []
        if (!this.$v.editedItem.course_id.$dirty) return errors
        !this.$v.editedItem.course_id.required && errors.push('Grupa jest wymagana')
        return errors
      },
      validErrors () {
        const errors = []
        if (!this.$v.editedItem.valid.$dirty) return errors
        !this.$v.editedItem.valid.required && errors.push('Musisz wybrać daty')
        return errors
      },
    },
    methods: {
      prolongTempCourse(item,type){
        this.$store.dispatch( 'prolongTempCourse',{slug:item.id,duration:type}); 
      },
    // addTempCourse(){
    //     this.$refs.confirm.open('Dostęp tymczasowy', 'Czy chcesz aktywować dostęp tymczasowy do wybranej grupy do końca dnia?', { color: 'error' }).then((confirm) => {
    //         if(confirm){
    //             this.$store.dispatch( 'addTempUserToCourse', {slug: this.selectedCourse ,id:  this.user.id});
    //         }
    //     })
    // },
      errorMessageArray(val) {
        const errors = val;
        var err = [];
        if(!errors)return [];

        if(errors.user_id){
          errors.user_id.forEach(e => {
            err.push(e);
          });
        }

        return err;
      },    
      close () {
        this.dialog = false
        this.$v.$reset()
        setTimeout(() => {
          this.$store.dispatch( 'loadTempCourseEditDefault'); 
          this.$store.dispatch( 'loadTempCourseAddDefault');
          this.itemEditing = false
        }, 300)
      },
      handleSubmit () {
        this.$v.$touch()
        if (this.$v.$invalid) {

        } else {
           this.$store.dispatch( 'addTempCourse', {
                user_id:  this.editedItem.user_id,
                course_id: this.editedItem.course_id,
                valid: this.editedItem.valid,
            });
        }
      },
    },
  }
</script>
<style scoped>
.search{
      max-width: 250px;
}
.choose_year{
      max-width: 150px;
}
</style>